export default {
  driverDatabase: 'Database Sopir',
  searchText: 'Cari Nama Sopir',
  photo: 'Foto',
  createDriver: 'Tambah Sopir',
  editDriver: 'Ubah Sopir',
  username: 'Nama Sopir',
  email: 'Email',
  phone: 'Nomor Telepon',
  licenseNo: 'Nomor Sim',
  licenseExpDate: 'Masa Berlaku Sim',
  createdBy: 'Dibuat Oleh',
  deleteDriverConfirmMsg: 'Apakah Anda yakin ingin menghapus akun sopir ini?',
  successDeleteDriverMsg: 'Berhasil menghapus akun',
  resetPasswordButtonLabel: 'Reset Password',
  resetPasswordConfirmMsg: 'Apakah Anda yakin ingin me-reset password akun ini?',
  resetPasswordSuccessMsg: 'Berhasil me-reset password akun',
}
